import { ProviderConfig, ProviderTypes } from 'types';
import { DefaultTheme } from 'config/themes';

export const MiFiber: ProviderConfig = {
  providerType: ProviderTypes.LEC,
  providerCode: 'mi-fiber',
  dcCode: 'mi-fiber',
  name: 'MiFiber',
  displayName: 'Mi-Fiber',
  reskinTheme: DefaultTheme,
  reskinTitle: 'Mi-Fiber Internet',
  showPricingDisclaimer: false,
  broadbandDisplayType: 'linkout_url',
};
